/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getId } from '@fluentui/react/lib/Utilities';
import { action, computed, observable } from 'mobx';
import { HealthcareEntityLink } from 'src/languageStudio/core/services/textAnalytics/textAnalyticsSwaggers';
import { BaseTokenStore } from 'src/packages/react-text-annotator/lib/esm';

type SelectableItem = { id: string; text: string };

export class HealthTokenStore extends BaseTokenStore {
    public readonly entityLinks: SelectableItem[];

    @observable public selectedLinkId: string;

    constructor(index: number, text: string, entityLinks: HealthcareEntityLink[]) {
        super(index, text);
        this.entityLinks = entityLinks.map(l => ({ id: getId(l.id), text: `${l.dataSource}: ${l.id}` }));
        this.selectedLinkId = this.entityLinks[0]?.id;
    }

    @computed
    public get visibleEntityLink(): SelectableItem {
        return this.selectedLinkId ? this.entityLinks.find(l => l.id === this.selectedLinkId) : this.entityLinks[0];
    }

    @action
    public setSelectedLink(linkId: string) {
        this.selectedLinkId = linkId;
    }
}
